import React, { ComponentProps } from 'react';
import { StyledButton } from './Button.styles';

export type ButtonProps = ComponentProps<typeof StyledButton> & {
  size?: 'small' | 'medium' | 'large';
  variant?: 'primary' | 'secondary' | 'tertiary' | 'error';
  width?: string;
  children?: React.ReactNode;
  'data-testid'?: string;
  className?: string;
  setRoot?:
    | ((instance: HTMLButtonElement | null) => void)
    | React.RefObject<HTMLButtonElement | null>
    | null
    | undefined;
  noTextWrap?: boolean;
  loading?: boolean;
  noPadding?: boolean;
  noMinWidth?: boolean;
  position?: string;
  justifyContent?: string;
};

export const Button = ({
  variant = 'primary',
  size = 'medium',
  disabled = false,
  loading = false,
  width,
  children,
  tabIndex = 0,
  type = 'button',
  noPadding = false,
  noMinWidth = false,
  setRoot,
  ...props
}: ButtonProps) => (
  <StyledButton
    variant={variant}
    size={size}
    width={width}
    justifyContent={props.justifyContent}
    disabled={disabled || loading}
    $loading={loading}
    data-testid={props['data-testid']}
    tabIndex={tabIndex}
    noPadding={noPadding}
    type={type}
    ref={setRoot}
    noMinWidth={noMinWidth}
    {...props}
  >
    {children}
  </StyledButton>
);
